import clsx from "clsx";
import { isEmptyOrWhitespace } from "@shoothill/core";

export const getInputClassNames = (className?: string): string => {
    return clsx({
        "drop-to-the-right": true,
        [className || ""]: !isEmptyOrWhitespace(className),
    });
};

export const getDataTestAttribute = (displayName?: string, cy?: string): string => {
    if (cy) return cy;
    const regex = /[^a-z]/gi;
    return (displayName || "").replace(regex, "");
};
